var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLoginLogo = function SvgLoginLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192.1 106.3",
    style: {
      enableBackground: "new 0 0 192.1 106.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#4E4E4E;}\r\n\t.st2{fill:#FFDD92;}\r\n\t.st3{fill:#966F4E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "159,88.2 96.8,106.3 33.9,88.2 46.8,35.2 146.1,35.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "159,88.2 146.1,35.2 119,35.2 119,99.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "192.1,21.3 96,0 0,21.3 0,30.3 96,59.4 192.1,30.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96,50.4 0.4,21.3 96,0 192.1,21.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.4,25.9c-0.2,1.1-1.2,1.8-2.2,1.6l-79.9-0.8c-1.1-0.2-1.8-1.2-1.6-2.2l0,0c0.2-1.1,1.2-1.8,2.2-1.6 l79.9,0.8C175.8,23.9,176.5,24.9,176.4,25.9L176.4,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177,49.3c0,1.1-0.9,1.9-1.9,1.9h-0.1c-1.1,0-1.9-0.9-1.9-1.9V25.1c0-1.1,0.9-1.9,1.9-1.9h0.1 c1.1,0,1.9,0.9,1.9,1.9V49.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 175.3,
    cy: 54.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184,93.7c0,1.4-1.1,2.5-2.5,2.5h-12.3c-1.4,0-2.5-1.2-2.5-2.5l2.5-25.9c0-1.4,1.1-2.5,2.5-2.5h7.4 c1.4,0,2.5,1.2,2.5,2.5L184,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181,63.7c0,1.4-1.1,2.5-2.5,2.5h-7.1c-1.4,0-2.5-1.1-2.5-2.5v-4.1c0-1.4,1.1-2.5,2.5-2.5h7.1 c1.4,0,2.5,1.1,2.5,2.5V63.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 96.3,
    cy: 24.5,
    rx: 12.2,
    ry: 4.4
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoginLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loginLogo.bc98a17a.svg";
export { ForwardRef as ReactComponent };